import { render } from "./ProHUBPage.vue?vue&type=template&id=2a31ea76&scoped=true"
import script from "./ProHUBPage.vue?vue&type=script&lang=js"
export * from "./ProHUBPage.vue?vue&type=script&lang=js"

import "./ProHUBPage.vue?vue&type=style&index=0&id=2a31ea76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a31ea76"]])

export default __exports__